import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MergeTagNode } from '../merge-tag-picker.model';

export interface MergeTagNodeToggleEvent {
	path: string;
	expanded: boolean;
}

@Component({
	selector: 'app-merge-tag-tree-node',
	templateUrl: './merge-tag-tree-node.component.html',
	styleUrls: ['./merge-tag-tree-node.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class MergeTagTreeNodeComponent {
	@Input({ required: true }) node!: MergeTagNode;
	@Input() expanded: boolean = false;
	@Input() expandedPaths: ReadonlySet<string> = new Set<string>();
	@Input() showExample: boolean = true;

	@Output() toggle = new EventEmitter<MergeTagNodeToggleEvent>();
	@Output() select = new EventEmitter<MergeTagNode>();

	onContainerClick(): void {
		if (this.node.isLeaf) {
			this.select.emit(this.node);
			return;
		}

		this.toggle.emit({ path: this.node.path, expanded: !this.expanded });
	}

	onToggle(event: MouseEvent): void {
		event.stopPropagation();

		if (!this.node.children?.length) {
			return;
		}

		this.toggle.emit({ path: this.node.path, expanded: !this.expanded });
	}

	childExpanded(path: string): boolean {
		return this.expandedPaths.has(path);
	}

	trackByPath(_: number, child: MergeTagNode): string {
		return child.path;
	}
}
